import { Avatar, HStack, Text } from '@chakra-ui/react';
import React from 'react';
import date from '../../../services/ui/date';
import { useTokens } from '../../../context/TokenProvider';
import { getCreatorName } from '../../../services/text/getCreatorName';
import { localise } from '../../../services/lang/lang';
const AVATAR_INITIALS_MAX_LIMIT = 3;
const NoteUserDetails = ({ note }) => {
    const tokens = useTokens();
    const getAvatarInitials = (name) => name
        .replace(`(${localise('DELETED_ACCOUNT')})`, '')
        .split(/\s+/)
        .slice(0, AVATAR_INITIALS_MAX_LIMIT)
        .map((word) => word.charAt(0))
        .join('')
        .toUpperCase();
    const creatorName = getCreatorName(note);
    return (React.createElement(HStack, { mb: tokens.Spacing02, gap: tokens.Spacing03 },
        React.createElement(Avatar, { size: "xs", name: creatorName, getInitials: () => getAvatarInitials(creatorName) }),
        React.createElement(Text, { "data-testid": "single_note__header", variant: "md-600-rg-5" },
            creatorName,
            " -",
            ' ',
            date.standard(note.client_updated_at ?? note.updated_at))));
};
export default NoteUserDetails;
